import request from '@/request/http'



// 获取未读消息数量
export function GetNotReadMessageCount(data) {
    return request({
        url: '/iam/messages/getNotReadMessageCount?messageType='+data,
        method: 'post',
    })
}



// 分页查询我的消息
export function PageQueryMyMessageList(data) {
    return request({
        url: '/iam/messages/pageQueryMyMessageList',
        method: 'post',
        data: data
    })
}

// 读取消息
export function ReadMessage(data) {
    return request({
        url: '/iam/messages/readMessage',
        method: 'post',
        data: data
    })
}
